var map = {
	"./components/AsideRightMenu.vue": "0I+6",
	"./components/Cart.vue": "w8HQ",
	"./components/CartMenuIcon.vue": "9rAg",
	"./components/CartPopup.vue": "7KnM",
	"./components/Checkout.vue": "jnWT",
	"./components/CheckoutManual.vue": "hunD",
	"./components/DeleteAddressPopup.vue": "ccTp",
	"./components/LoginPopup.vue": "U5dA",
	"./components/NewAddressPopup.vue": "xfUR",
	"./components/Notifications.vue": "vMIN",
	"./components/NutritionalLabel.vue": "+Y/r",
	"./components/ProductBuy.vue": "5rrd",
	"./components/ProductBuySimple.vue": "Nh9Z",
	"./components/ProductBuyVisite.vue": "27Bs",
	"./components/ProductDisplayYearAndPrice.vue": "ewyR",
	"./components/RecycleLabel.vue": "aRQM",
	"./components/ShopMenuIcon.vue": "j7FO",
	"./components/SimpleCartIcon.vue": "aHcI",
	"./components/UserMenu.vue": "ShWE",
	"./components/partials/DiscountBox.vue": "fM7T",
	"./components/partials/OrderAnalytics.vue": "O9Pz",
	"./components/partials/RegistrationAnalytics.vue": "Nxk2",
	"./components/user-account/AccountUserAddresses.vue": "XF9s",
	"./components/user-account/AccountUserBilling.vue": "I5/O",
	"./components/user-account/AccountUserData.vue": "FYgi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "j8KI";